export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "---",
    },
    {
      value: 1,
      name: "Discount",
      text: "打折",
    },
    {
      value: 2,
      name: "Total",
      text: "改變總價",
    },
    {
      value: 3,
      name: "TotalFreePrice",
      text: "折價",
    },
    {
      value: 4,
      name: "FreePricePerItem",
      text: "單價折價",
    },
    {
      value: 5,
      name: "FreeItem",
      text: "贈送商品",
    },
    {
      value: 6,
      name: "ChangeSalPrice",
      text: "改變單價",
    },
  ];
}

export function getByValue(value) {
  return getAll().find((item) => item.value == value);
}
